import * as React from 'react';
import { buildAdapter } from '../../../grouped-table/helper';
import { Configure, InstantSearch, ClearRefinements } from 'react-instantsearch';
import HitsWidget from './HitsWidget';
import Filter from './filter/Filter';
import GroupLabel from './GroupLabel';
import { chartStyles, filtersConfig, futureFlags, typesenseClientConfig, withYAxis } from '../../helpers';
import Preloader from '../Preloader';
import ChartLayout from '../ChartLayout';
import { useFacetBootstrap } from '../../api';

export default function TypesenseProvider({ defaultIndex, collectionName, currentGroup, style, lineStyle, title, collapsibleFilters, imageFooter, groups, groupLabel, handleGroupChange }) {
  const adapter = React.useMemo(() => buildAdapter(defaultIndex, typesenseClientConfig), [defaultIndex]);

  const facets = currentGroup.filters ? currentGroup.filters.map(item => item.attribute).join(',') : '';
  const bootstrapConfig = currentGroup.label ? {
    adapter,
    facets,
    index: defaultIndex,
    filters: currentGroup.filters,
    filterBy: currentGroup.filterBy,
    groupByFields: currentGroup.groupByFields,
  } : {};
  const { loading, initialUiState, facetCounts } = useFacetBootstrap(bootstrapConfig);

  const css = React.useMemo(() => chartStyles(style), [style]);
  const configuredFilters = filtersConfig(currentGroup);

  if (loading || !initialUiState) {
    return <Preloader title='Chart'/>;
  }

  const renderFilter = (filter, filterIndex) => (
    <Filter
      key={filter.attribute}
      group={currentGroup}
      config={filter}
      facetCounts={facetCounts}
      isFirstFacet={filterIndex === 0}
    />
  );

  return (
    // key= forces InstantSearch to fully reset state when the user switches groups.
    <div className='nv-chart-group' key={currentGroup.label}>
      <InstantSearch
        searchClient={adapter.searchClient}
        indexName={defaultIndex}
        initialUiState={initialUiState}
        future={futureFlags()}>
        <Configure hitsPerPage={250} {...(configuredFilters ? { filters: configuredFilters } : {})}/>
        <ChartLayout
          css={css}
          title={title}
          collapsibleFilters={collapsibleFilters}
          imageFooter={imageFooter}
          currentGroup={currentGroup}
          groups={groups}
          groupLabel={groupLabel}
          handleGroupChange={handleGroupChange}
          renderFilter={renderFilter}
          renderGroupLabel={() => <GroupLabel currentGroup={currentGroup}/>}
          renderHits={(yAxis) => <HitsWidget chartConfig={withYAxis(currentGroup, yAxis)} lineStyle={lineStyle}/>}
          collectionName={collectionName}
          clearAllSidebar={<div className='d-none clear-group-filters'><ClearRefinements/></div>}
        />
      </InstantSearch>
    </div>
  );
}
